import { render, staticRenderFns } from "./defaultEntry.vue?vue&type=template&id=1038657f&scoped=true"
import script from "./defaultEntry.vue?vue&type=script&lang=js"
export * from "./defaultEntry.vue?vue&type=script&lang=js"
import style0 from "./defaultEntry.vue?vue&type=style&index=0&id=1038657f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1038657f",
  null
  
)

export default component.exports